module.exports = __webpack_public_path__ + "img/yesmovies-secure-vpn.89bca350.png";